import {
  j
} from "./chunk.BPIW577J.js";

// node_modules/.pnpm/lit-html@3.3.3/node_modules/lit-html/directive-helpers.js
var { I: t } = j;
var i = (o) => o;
var r = (o) => void 0 === o.strings;
var s = () => document.createComment("");
var v = (o, n, e) => {
  const l = o._$AA.parentNode, d = void 0 === n ? o._$AB : n._$AA;
  if (void 0 === e) {
    const i2 = l.insertBefore(s(), d), n2 = l.insertBefore(s(), d);
    e = new t(i2, n2, o, o.options);
  } else {
    const t2 = e._$AB.nextSibling, n2 = e._$AM, c = n2 !== o;
    if (c) {
      let t3;
      e._$AQ?.(o), e._$AM = o, void 0 !== e._$AP && (t3 = o._$AU) !== n2._$AU && e._$AP(t3);
    }
    if (t2 !== d || c) {
      let o2 = e._$AA;
      for (; o2 !== t2; ) {
        const t3 = i(o2).nextSibling;
        i(l).insertBefore(o2, d), o2 = t3;
      }
    }
  }
  return e;
};
var u = (o, t2, i2 = o) => (o._$AI(t2, i2), o);
var m = {};
var p = (o, t2 = m) => o._$AH = t2;
var M = (o) => o._$AH;
var h = (o) => {
  o._$AR(), o._$AA.remove();
};

export {
  r,
  v,
  u,
  p,
  M,
  h
};
/*! Bundled license information:

lit-html/directive-helpers.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
